import React from "react";
import { InputContainerProps } from "./types";
import TwireInput from "./TwireInput";

const TwireInputContainer: React.FC<InputContainerProps> = (props) => {
  return <TwireInput {...props} />;
};

export default TwireInputContainer;
